import * as React from 'react';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { authManage } from 'src/api';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import { history } from 'kts-platform-frame/routes';
import { Modal, message } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';
import InvoiceImport from 'kts-platform-frame/display/part/InvoiceImport';

class ModulesAction extends ActionBasic<ModulesState> {
    public handleSelectFilter = (fields) => {
        this.modulesState.selectFields = fields;
        this.modulesState.selectFilter = fields;
        this.modulesState.selectInvoiceListData = [];
        this.modulesState.selectPageNumber = 1;
        this.modulesState.selectHasMore = true;
        this.modulesState.draftedInvoiceId = [];
        this.setModulesState();
    }
    onSelectAll = () => {
        this.modulesState.selectInvoiceListData = [];
        this.modulesState.selectPageNumber = 1;
        this.modulesState.selectHasMore = true;
        this.modulesState.draftedInvoiceId = [];
        this.setModulesState();
        const values = this.modulesState.selectFields;
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const data = {
            ...values,
            companyId,
        };
        if (values && values["minInvoiceDate"]) {
            data["minInvoiceDate"] = values["minInvoiceDate"].format("YYYY-MM-DD");
        }
        if (values && values["maxInvoiceDate"]) {
            data["maxInvoiceDate"] = values["maxInvoiceDate"].format("YYYY-MM-DD");
        }
        authManage.selectAllDraft(this, data).then((response: any) => {
            const res = response.res;
            if (res) {
                this.updateSelect({});
                this.updateCount();
            }
        });
    }
    onUnselectAll = () => {
        this.modulesState.selectInvoiceListData = [];
        this.modulesState.selectPageNumber = 1;
        this.modulesState.selectHasMore = true;
        this.modulesState.draftedInvoiceId = [];
        this.setModulesState();
        const values = this.modulesState.selectFields;
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const data = {
            ...values,
            companyId,
        };
        if (values && values["minInvoiceDate"]) {
            data["minInvoiceDate"] = values["minInvoiceDate"].format("YYYY-MM-DD");
        }
        if (values && values["maxInvoiceDate"]) {
            data["maxInvoiceDate"] = values["maxInvoiceDate"].format("YYYY-MM-DD");
        }
        authManage.unselectAllDraft(this, data).then((response: any) => {
            this.updateSelect({});
            this.updateCount();
        });
    }
    public updateSelect = async (params: any, page?: number, callback?: any) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const values = this.modulesState.selectFields;
        const userId = user.userInfo.cUserId;
        const data = {
            ...values,
            companyId,
            pageNum: page || this.modulesState.selectPageNumber,
            pageSize: this.modulesState.selectPageSize,
        };
        if (values && values["minInvoiceDate"]) {
            data["minInvoiceDate"] = values["minInvoiceDate"].format("YYYY-MM-DD");
        }
        if (values && values["maxInvoiceDate"]) {
            data["maxInvoiceDate"] = values["maxInvoiceDate"].format("YYYY-MM-DD");
        }
        const selectInvoiceList = await authManage.updateSelectList(this, data);
        if (selectInvoiceList.er || !selectInvoiceList.res) {
            return;
        }
        const { pageMeta } = selectInvoiceList.res;
        if (pageMeta.pageNum * pageMeta.pageSize > pageMeta.total) {
            this.modulesState.selectHasMore = false;
        }
        this.modulesState.selectPageNumber = this.modulesState.selectPageNumber + 1;
        this.modulesState.selectLoading = false;
        this.modulesState.selectInvoiceListData = this.modulesState.selectInvoiceListData.concat(selectInvoiceList.res.items);
        this.modulesState.selectTotal = selectInvoiceList.res.pageMeta.total;
        const _draftedInvoiceId = selectInvoiceList.res.items
            .filter(item => { return ((item.draftState === 'DRAFT_COMMIT') || item.draftState === 'DRAFT_PUSHED' || item.draftState === 'DRAFT_COMMIT_ING' || item.draftState === 'DRAFT_CANEL_ING'); })
            .map(item => item.incomeInvoiceBizId);
        this.modulesState.draftedInvoiceId = Array.from(new Set(this.modulesState.draftedInvoiceId.concat(_draftedInvoiceId)));
        this.setModulesState(this.modulesState);
        if (callback) {
            callback(selectInvoiceList.res.items);
        }
    }

    public changeTab = (e: string): void => {
        this.modulesState.currentTab = e;
        // this.modulesState.filterDisplay = false;
        if (e === '1') {
            history.push('/workbench/authManage/authSelect');
            this.refresh(1);
        }
        if (e === '2') {
            history.push('/workbench/authManage/authConfirm');
            this.modulesState.confirmRandom = Math.random();
            this.refresh(2);
        }
        if (e === '3') {
            history.push('/workbench/authManage/authRecord');
            this.refresh(3);
        }
        if (e === '4') {
            history.push('/workbench/authManage/authStatics');
        }
        if (e === '5') {
            history.push('/workbench/authManage/authlogging');
        }
        //this.modulesState.selectFields = null;
        //this.modulesState.confirmFields = null;
        this.setModulesState();

    }
    public showInvoiceInPanel = (callback) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const downloadUrl = `${Urls.INVOICE_AUTH_DOWNLOAD_FILE}?companyId=${companyId}`;
        const urlData = {
            // key4: Urls.logInvoiceMANUAL,
            scankey4: Urls.INVOICE_AUTH_QRCODE,
            //downloadurl: downloadUrl,
            url: Urls.INVOICE_AUTH_DRAFT_BY_FILE,
            scankey4type: 'get',
        };
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={() => { callback(); }} />,
            title: '发票勾选'
        });
    }
    public showDeductionInPanel = (callback) => {
        const { user } = MyStore.instance.getState();
        const urlData = {
            key4: Urls.deduction_manualOrScanner,
            key4inputType: 3,
            imageinputType: 5,
            ocrinputType: 2,
            scankey4: Urls.deduction_manualOrScanner,
            scaninputType: 1,
            qrtoken: Urls.deduction_createOcrToken,
            downloadurl: Urls.deduction_downloadTemplate,
            url: Urls.deduction_excel,
            scanerurl: Urls.deduction_createOcrToken,
            deduction: true,

        };
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={() => { callback(); }} />,
            title: '认证录入'
        });
    }
    public updateConfirm = async (params?: any, page?: number) => {
        const { user } = MyStore.instance.getState();
        const { companyId, } = user.userInfo;
        const userId = user.userInfo.cUserId;
        const values = this.modulesState.confirmFields;
        const data = {
            ...values,
            companyId,
            pageNum: page || this.modulesState.confirmPageNumber,
            pageSize: this.modulesState.confirmPageSize,
            draftOperator: userId,
        };
        // if (data['authStates'] && data['authStates'].indexOf('UNCHECK') >= 0) {
        //     data['authStates'] = Array.from(new Set([...data['authStates'], ...['CHECKING', 'FAILED']]));
        // }
        if (values && values["minInvoiceDate"]) {
            data["minInvoiceDate"] = values["minInvoiceDate"].format("YYYY-MM-DD");
        }
        if (values && values["maxInvoiceDate"]) {
            data["maxInvoiceDate"] = values["maxInvoiceDate"].format("YYYY-MM-DD");
        }
        const confirmInvoiceList = await authManage.updateConfirmList(this, data);
        if (confirmInvoiceList.er || !confirmInvoiceList.res) {
            return;
        }

        const { pageMeta } = confirmInvoiceList.res;
        if (pageMeta.pageNum * pageMeta.pageSize > pageMeta.total) {
            this.modulesState.confirmHasMore = false;
        }
        this.modulesState.confirmPageNumber = this.modulesState.confirmPageNumber + 1;
        this.modulesState.confirmLoading = false;
        this.modulesState.confirmInvoiceListData = this.modulesState.confirmInvoiceListData.concat(confirmInvoiceList.res.items);
        this.modulesState.confirmTotal = confirmInvoiceList.res.pageMeta.total;
        const _draftedInvoiceId = confirmInvoiceList.res.items
            .map(item => item.incomeInvoiceBizId);

        this.modulesState.draftedInvoiceId = this.modulesState.draftedInvoiceId.concat(_draftedInvoiceId);
        this.setModulesState();
    }
    public refresh = (num: number): void => {
        if (num === 1) {
            this.modulesState.selectRandom = Math.random();
        } else if (num === 2) {
            this.modulesState.confirmRandom = Math.random();
        } else if (num === 3) {
            this.modulesState.recordRandom = Math.random();
        }
        else {
            console.error('num参数错误', num);
        }
        this.setModulesState(this.modulesState);
    }
    //确认列表上那个数字 统计勾选
    public updateCount = async (params?: any) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        const cUserId = user.userInfo.cUserId;
        const _count = await authManage.updateCount(this, { companyId, draftOperator: cUserId, draftState: 'DRAFT_COMMIT' });
        if (_count.er || !_count.res) {
            return;
        }
        this.modulesState.draftedLength = await _count.res.incomeInvoiceBizIdTotal;
        this.modulesState.draftedAmount = await _count.res.amountWithoutTaxTotal;
        this.modulesState.draftedTax = await _count.res.amountTaxTotal;
        this.setModulesState(this.modulesState);

    }
    public handleDraftInvoice = async (arr) => {
        const data = { list: arr };
        const draftedInvoiceResult = await authManage.draftInvoice(this, data);
        let { selectInvoiceListData } = this.modulesState;
        if (draftedInvoiceResult.er) {
            if (draftedInvoiceResult.er.body.body) {
                message.error(draftedInvoiceResult.er.body.body.faildList[0].checkResultMsg);
            }
            draftedInvoiceResult.er.body.body.successList.map((item) => {
                if (item.incomeInvoiceBizId) {
                    this.modulesState.draftedInvoiceId.push(item.incomeInvoiceBizId.toString());
                }
            });
        } else {
            draftedInvoiceResult.res.successList.map((item) => {
                if (item.incomeInvoiceBizId) {
                    this.modulesState.draftedInvoiceId.push(item.incomeInvoiceBizId.toString());
                    for (let i = 0; i < selectInvoiceListData.length; i++) {
                        if (item.incomeInvoiceBizId === selectInvoiceListData[i].incomeInvoiceBizId) {
                            selectInvoiceListData[i].draftOperatorName = item.draftOperatorName;
                        }
                    }
                }
            });
        }
        this.modulesState.draftedInvoiceId = Array.from(new Set(this.modulesState.draftedInvoiceId));
        //this.modulesState.selectRandom = Math.random();
        this.setModulesState(this.modulesState);
        this.updateCount();
    }
    public handleUndraftInvoice = async (arr, callback?: any) => {
        const data = { list: arr };
        const draftedInvoiceResult = await authManage.undraftInvoice(this, data);
        let { draftedInvoiceId, selectInvoiceListData } = this.modulesState;
        let children = draftedInvoiceResult.res.successList;
        for (let i = 0; i < children.length; i++) {
            if (draftedInvoiceId.indexOf(children[i].incomeInvoiceBizId) >= 0) {
                draftedInvoiceId.splice(draftedInvoiceId.indexOf(children[i].incomeInvoiceBizId), 1);
            }
            for (let x = 0; x < selectInvoiceListData.length; x++) {
                if (children[i].incomeInvoiceBizId === selectInvoiceListData[x].incomeInvoiceBizId) {
                    selectInvoiceListData[x].draftOperatorName = '';
                }
            }
        }
        this.setModulesState(this.modulesState).then(() => {
            if (callback) {
                callback();
            }
        });
        this.updateCount();

    }
    public undraftInvoiceByUser = async (id, callback?: Function) => {
        const _result = await authManage.undraftInvoiceByUser(this, id);
        this.modulesState.confirmRandom = Math.random();
        this.setModulesState(this.modulesState);
        if (callback) {
            callback();
        }
    }
    public toggleFilter = () => {
        this.modulesState.filterDisplay = !this.modulesState.filterDisplay;
        this.setModulesState();
    }
    public handleSelectPageChange = async (page: number) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        this.modulesState.selectPageNumber = page;
        if (this.modulesState.selectFields) {
            this.updateSelect({ companyId, authState: 'UNCHECK', pageNum: page, pageSize: 10, ...this.modulesState.selectFields });
        } else {
            this.updateSelect({ companyId, authState: 'UNCHECK', pageNum: page, pageSize: 10 });
        }


    }

    public handleConfirmPageChange = async (page: number) => {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        this.modulesState.confirmPageNumber = page;
        if (this.modulesState.confirmFields) {
            this.updateConfirm({ companyId, draftState: 'DRAFT_COMMIT', pageNum: page, pageSize: 10, ...this.modulesState.confirmFields });
        } else {
            this.updateConfirm({ companyId, draftState: 'DRAFT_COMMIT', pageNum: page, pageSize: 10 });
        }

    }
    public handleConfirmFilter = (fields) => {
        this.modulesState.confirmFields = fields;
        this.modulesState.comfirmFilter = fields;
        this.modulesState.confirmInvoiceListData = [];
        this.modulesState.confirmPageNumber = 1;
        this.modulesState.confirmHasMore = true;
        this.setModulesState(this.modulesState);
    }
    public handleCommit = async (data) => {
        const result = await authManage.invoiceCommit(this, data);

        this.modulesState.authNoteDisplay = false;
        this.setModulesState();
        if (result.er) {
            // message.info(result.er.status.description)
            return;
        }

        this.refresh(1);
        this.updateCount();
        Modal.info({
            title: '操作成功',
            content: '确认结果提交完毕，请稍后跟踪认证结果!',
            onOk: () => {
                this.changeTab("3");
            }
        });
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/Modules.Action.tsx